import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import Button from "components/common/Button";

import styles from "./styles.module.scss";

export default function NoDataTable({ urlToAdd, message, showButton = true }) {
    const { t } = useTranslation();
    const authenticated = useSelector((state) => state.auth.authenticated);

    return (
        <div className={styles.noData}>
            <p className={styles.noData_message}>{message}</p>
            {authenticated && showButton && (
                <Button className={styles.noData__link} to={urlToAdd}>
                    {t("add")}
                </Button>
            )}
        </div>
    );
}
